import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Category } from '@core/model/category.model';
import { CategoryService } from '@app/core';
import Swal from 'sweetalert2';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CategoryCreateComponent } from '@app/dashboard/category/category-create/category-create.component';
import { Paginated } from '@app/core/model/paginated.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.css']
})
export class CategoryListComponent implements OnInit {
  categoryForm: FormGroup;
  categories: Category[];
  Category: any = {};
  estado: boolean;
  idCategory: string;
  private modalOptions: NgbModalOptions;
  closeResult: string;

  pager = {};
  pageOfItems: any = [];

  categorias: Paginated;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;

  constructor(
    private formBuilder: FormBuilder,
    public categoryService: CategoryService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.createForm();

    this.categoryService
      .getCategorias()
      .then(categorias => (this.categorias = categorias));
    this.searchTermStream.subscribe((term: string) => {
      this.categoryService.search(term).then((categorias: any) => {
        this.currentSearchTerm = term;
        this.updateCategorias(categorias);
      });
    });
  }

  updateCategorias(categorias: Paginated) {
    const productosWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      categorias
    );
    this.categorias = productosWithUpdatedNavs;
  }

  updateNavUrls(term: string, categorias: Paginated): Paginated {
    if (term) {
      if (categorias.prev_page_url) {
        categorias.prev_page_url += `&term=${term}`;
      }
      if (categorias.next_page_url) {
        categorias.next_page_url += `&term=${term}`;
      }
    }
    return categorias;
  }

  prevPage() {
    this.categoryService
      .getProductosAtUrl(this.categorias.prev_page_url)
      .then((productos: any) => {
        this.updateCategorias(productos);
      });
  }

  nextPage() {
    this.categoryService
      .getProductosAtUrl(this.categorias.next_page_url)
      .then((productos: any) => {
        this.updateCategorias(productos);
      });
  }

  search(term: string) {
    this.searchTermStream.next(term);
  }

  createForm() {
    this.categoryForm = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  listCategories() {
    this.categoryService.getAll().subscribe(
      data => {
        this.categories = data;
        //  console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerCategory() {
    console.log(this.categoryForm.value);
    this.Category.nombre = this.categoryForm.value.nombre;
    this.Category.descripcion = this.categoryForm.value.descripcion;
    // console.log(this.Category);
    if (this.estado === true) {
      this.categoryService.update(this.idCategory, this.Category).subscribe(
        data => {
          Swal.fire(data);
          this.listCategories();
          this.categoryForm.reset();
          this.estado = false;
        },
        error1 => {
          Swal.fire(error1.error);
        }
      );
    } else {
      this.categoryService.create(this.Category).subscribe(
        data => {
          // alert('Fue creado satisfactoriamente');
          Swal.fire(data);
          this.listCategories();
          this.categoryForm.reset();
        },
        error => {
          Swal.fire(error.error);
        }
      );
    }
  }

  enableCategory(id: number) {
    this.categoryService.enableCategory(id).subscribe(
      data => {
        this.listCategories();
      },
      error => {
        console.log(error.error);
      }
    );
  }

  editCategory(categoria_id: string): Category {
    this.idCategory = categoria_id;
    this.estado = true;
    this.categoryService.getById(categoria_id).subscribe(
      data => {
        this.Category = data;
        //  console.log(this.Category);
      },
      error1 => console.log(error1)
    );
    return this.Category;
  }

  editModal(categoria_id: string) {
    const modal = this.modalService.open(
      CategoryCreateComponent,
      this.modalOptions
    );
    // modal.componentInstance.category2 = this.editCategory(categoria_id);
    modal.componentInstance.category2_id = categoria_id;
    modal.componentInstance.estado = true;
    modal.componentInstance.titulo = 'Editar Categoria';

    modal.result.then(result => {
      if (result) {
        this.categoryService
          .getCategorias()
          .then(categorias => (this.categorias = categorias));
        this.searchTermStream.subscribe((term: string) => {
          this.categoryService.search(term).then((productos: any) => {
            this.currentSearchTerm = term;
            this.updateCategorias(productos);
          });
        });
      }
    });
  }

  createCategory() {
    const modalRef = this.modalService.open(
      CategoryCreateComponent,
      this.modalOptions
    );
    modalRef.componentInstance.titulo = 'Crear categoría';
    modalRef.result.then(result => {
      if (result) {
        this.categoryService
          .getCategorias()
          .then(categorias => (this.categorias = categorias));
        this.searchTermStream.subscribe((term: string) => {
          this.categoryService.search(term).then((productos: any) => {
            this.currentSearchTerm = term;
            this.updateCategorias(productos);
          });
        });
      }
    });
  }
}
